<template>
  <div>
    <policy :clcki-name="clckiName" />
  </div>
</template>

<script>
// 获取接口地址
import Policy from '../components/xxhd/zcwj/policy.vue'

export default {
  name: 'Zcwj',
  components: {
    Policy
    // sideMenu,
    // Header
  },
  data() {
    return {
      clckiName: '详情'
    }
  },
  created: function() {},
  methods: {}
}
</script>

<style scoped>
</style>
